<template>
    <ModeSwitcher
        ref="modeSwitcher"
        :main-mode-text="$t('create')"
        :create-mode-text="$t('create_b2c')"
        :edit-mode-text="`${$t('edit_b2c')}, ${selectedB2C?.name}`"
        class="pt-4"
        @reset="selectedB2C = null"
    >
        <template v-slot:main-mode>
            <v-data-table
                :headers="useHeaders"
                :items="b2cList"
                :items-per-page-options="useTableOptions(b2cList.length)"
                :items-length="b2cList.length"
                density="compact"
                class="elevation-1 table-server"
                must-sort
                fixed-header
            >
                <template v-slot:item.name="{item}">
                    <span class="text-link" @click="editB2C(item)">
                        {{ item.name }}
                    </span>
                </template>
                <template v-slot:item.url="{item}">
                    <a :href="item.url" target="_blank">{{ item.url }}</a>
                </template>
            </v-data-table>
        </template>
        <template v-slot:additional-mode>
            <B2CSalesSettings :b2c-id="selectedB2C?.b2cId" @save="save()" @cancel="modeSwitcher.goToTable()" />
        </template>
    </ModeSwitcher>
</template>

<script setup lang="ts">
    import {useTableOptions} from '~/composables/helpers'

    const modeSwitcher = ref(null)
    const isLoading = ref<boolean>(false)
    const b2cList = ref([])
    const selectedB2C = ref<any>()

    const {$api, $toast} = useNuxtApp()
    const {t} = useI18n()

    onMounted(async () => {
        await loadData()
    })

    async function loadData(): Promise<void> {
        isLoading.value = true
        try {
            b2cList.value = (await $api.b2c.get()).b2cs
        } catch (e) {
            $toast.error(t('error_message.load_error'))
        } finally {
            isLoading.value = false
        }
    }

    const useHeaders = computed(() => {
        return [
            {title: t('name'), value: 'name', minWidth: '150px', sortable: true},
            {title: t('url'), value: 'url'},
        ]
    })

    const editB2C = (b2c): void => {
        selectedB2C.value = b2c
        modeSwitcher.value.edit()
    }

    const save = async (): Promise<void> => {
        modeSwitcher.value.goToTable()
        await loadData()
    }
</script>
